export const en = {
  "language.label": "Language",
  "language.el": "Ελληνικά",
  "language.en": "English",
  "language.fr": "Français",

  "common.loading": "Loading...",
  "common.error": "Error",
  "common.empty": "Empty",
  "common.save": "Save",
  "common.cancel": "Cancel",
  "common.edit": "Edit",
  "common.delete": "Delete",
  "common.back": "Back",
  "common.open": "Open",
  "common.search": "Search",
  "common.signIn": "Sign in",
  "common.signOut": "Sign out",
  "common.signInGoogle": "Sign in with Google",
  "common.downloadPuls": "Download PULS",
  "common.downloadPulsBody": "Keep using the web viewer or download the app for full recording, notifications and participation.",
  "common.permissionDenied": "Permission denied",
  "common.notFound": "Not found",
  "common.noDataYet": "No data yet",
  "common.viewActions": "View Actions",
  "common.viewLocation": "Location",
  "common.refreshLater": "Try again in a moment.",
  "common.noDate": "No date",
  "common.status": "Status",
  "common.confirm": "Confirm",

  "app.subtitle": "PULS V2 web portal",
  "app.routeLoadingTitle": "Loading PULS...",
  "app.routeLoadingBody": "This section is opening now.",

  "auth.title": "Sign in to PULS",
  "auth.body": "Sign in with Google to open the web portal. Guest mode is not available.",
  "auth.loading": "Checking session...",
  "auth.signingIn": "Signing in...",
  "auth.error": "Sign-in failed. Check that the popup was not blocked and try again.",
  "auth.privacy": "Privacy policy",
  "auth.deleteAccount": "Account deletion",
  "auth.guest": "Guest",
  "auth.fullAccess": "Sign in for full access",

  "nav.home": "Home",
  "nav.dashboard": "Dashboard",
  "nav.brevetActions": "Brevet / Actions",
  "nav.actions": "Actions",
  "nav.myActions": "My actions",
  "nav.routes": "Routes",
  "nav.myRoutes": "My routes",
  "nav.routeEditor": "Edit / Create",
  "nav.community": "Community",
  "nav.communityRoutes": "Community routes",
  "nav.segments": "Segments",
  "nav.segmentRankings": "Segment rankings",
  "nav.tasks": "Tasks",
  "nav.invitations": "Invitations",
  "nav.sosHelp": "SOS / Help",
  "nav.supportControl": "Support / Control",
  "nav.settings": "Settings",
  "nav.profile": "Profile",
  "nav.segmentDetail": "Segment detail",
  "nav.results": "Results",
  "nav.liveBrevet": "Live Brevet",
  "nav.publicTracking": "Public tracking",
  "nav.actionDetails": "Action details",
  "nav.routeEditorFull": "Edit / Create route",
  "nav.adminSection": "Administration",
  "nav.admin": "Admin panel",

  "dashboard.loadingTitle": "Loading PULS",
  "dashboard.loadingBody": "Checking your session.",
  "dashboard.publicTitle": "PULS Control Center",
  "dashboard.publicBody": "Public action and share-link viewer, with a personal dashboard after sign-in.",
  "dashboard.welcomeTitle": "Welcome to PULS",
  "dashboard.welcomeBody":
    "You can view public actions and live links. Sign in with Google for personal tasks, routes, organizing and profile tools.",
  "dashboard.title": "Dashboard",
  "dashboard.subtitle": "Overview of pending tasks, your actions, routes and live streams.",
  "dashboard.newAction": "New Action",
  "dashboard.newRoute": "New Route",
  "dashboard.openTasks": "Open Tasks",
  "dashboard.pendingTitle": "Pending / Tasks",
  "dashboard.pendingDescription": "Invitations, support/control and SOS items that need attention.",
  "dashboard.total": "Total",
  "dashboard.myActionsTitle": "My actions",
  "dashboard.myActionsDescription": "Upcoming or active actions where you are the organizer.",
  "dashboard.myActionsEmpty": "You have no upcoming or active actions.",
  "dashboard.myRoutesTitle": "My routes",
  "dashboard.myRoutesDescription": "Recent saved or imported routes from your account.",
  "dashboard.synced": "synced",
  "dashboard.recent": "Recent",
  "dashboard.noRoutes": "No synced routes yet.",
  "dashboard.liveNowTitle": "Live now",
  "dashboard.liveNowDescription": "Active actions with quick access to the live race view.",
  "dashboard.liveNowEmpty": "You do not have an active action right now.",
  "dashboard.liveAccessEmpty": "There are no active actions with live access right now.",
  "dashboard.openLive": "Open Live",
  "dashboard.shortcutsTitle": "Quick actions",
  "dashboard.shortcutsDescription": "Common tools for organizing, routes and your account.",
  "dashboard.importRoute": "Import GPX/TCX/KML",
  "dashboard.sectionLoadError": "This section could not be loaded.",

  "admin.title": "Admin panel",
  "admin.subtitle": "Professional overview for actions, live operations, pending work and basic system status.",
  "admin.loadingTitle": "Checking access",
  "admin.loadingBody": "Checking admin permissions.",
  "admin.loadingDataTitle": "Loading admin data",
  "admin.loadingDataBody": "Reading safe summaries.",
  "admin.loadErrorTitle": "Could not load",
  "admin.loadErrorBody": "Try again in a moment.",
  "admin.partialError": "Some management sections did not load.",
  "admin.availabilityTitle": "Admin data availability",
  "admin.availabilityAllowed": "Allowed",
  "admin.availabilityPartial": "Partial availability",
  "admin.availabilityBlocked": "Blocked",
  "admin.availabilitySection": "Section",
  "admin.availabilityReason": "Reason",
  "admin.availabilityDetails": "Details",
  "admin.availabilityErrors": "Error labels",
  "admin.availabilityReasonOk": "This section loaded with the current permissions.",
  "admin.availabilityPartialReason": "Part of the available data loaded.",
  "admin.availabilityBlockedReason": "Not allowed by the current rules.",
  "admin.availabilityRulesChangeRequired": "Rules change required",
  "admin.availabilityLiveMirrors": "Live mirrors",
  "admin.availabilityLiveMirrorsLoaded": "{loaded}/{total} live event mirrors loaded.",
  "admin.availabilityActions": "Actions",
  "admin.availabilityUsers": "Users",
  "admin.availabilityPending": "Pending work",
  "admin.availabilitySos": "SOS / Help",
  "admin.availabilityCommunity": "Community",
  "admin.availabilityLive": "Live problems",
  "admin.accessDeniedTitle": "You do not have access to this page.",
  "admin.accessDeniedBody": "This section is available only to admin accounts.",
  "admin.totalActions": "Total actions",
  "admin.activeActions": "Live now",
  "admin.upcomingActions": "Upcoming",
  "admin.openHelp": "Open SOS",
  "admin.communityRoutes": "Community routes",
  "admin.communitySegments": "Community segments",
  "admin.users": "Users",
  "admin.liveNow": "Live now",
  "admin.liveNowDescription": "Active actions with quick access to the live race view.",
  "admin.noLiveNow": "No action is live right now.",
  "admin.pendingTitle": "System pending",
  "admin.pendingDescription": "Invitations, support/control and SOS items that need attention.",
  "admin.pendingInvitations": "Invitations",
  "admin.pendingSupportControl": "Support/Control",
  "admin.openSos": "SOS",
  "admin.openTasks": "Total",
  "admin.recentActions": "Recent actions",
  "admin.recentActionsDescription": "Recently updated actions with quick open or edit access.",
  "admin.noActions": "No actions available.",
  "admin.noSearchResults": "No results found.",
  "admin.quickActions": "Quick actions",
  "admin.quickActionsDescription": "Shortcuts for core admin workflows.",
  "admin.usersTitle": "Users / Cyclists",
  "admin.usersDescription": "Safe name, role and status view without private fields.",
  "admin.userCard": "Card",
  "admin.cyclistCardTitle": "Cyclist card",
  "admin.basicInfo": "Basic info",
  "admin.basicInfoBody": "Account fields that an admin is allowed to view.",
  "admin.technicalInfo": "Admin technical info",
  "admin.technicalInfoBody": "Useful for checking live participation and support.",
  "admin.databaseId": "Database ID",
  "admin.authUid": "Auth UID",
  "admin.copyId": "Copy ID",
  "admin.idCopied": "The ID was copied.",
  "admin.displayName": "Name",
  "admin.email": "Email",
  "admin.createdAt": "Created",
  "admin.action": "Action",
  "admin.role": "Role",
  "admin.status": "Status",
  "admin.date": "Date",
  "admin.athleteNumber": "Athlete number",
  "admin.memberships": "Participations / Actions",
  "admin.membershipsBody": "Actions where this user appears as athlete, organizer, support or control.",
  "admin.liveNowUserBody": "Live entries where this user appears in the public live mirror.",
  "admin.liveIssueTitle": "Live check",
  "admin.liveIssueBody": "Quick check of live presence and support diagnostics.",
  "admin.liveEntriesCount": "Live entries",
  "admin.liveDelayedCount": "Stale / offline",
  "admin.lastUpdate": "Last update",
  "admin.lastKnownEvent": "Last action",
  "admin.liveStatusLive": "Live now",
  "admin.liveStatusStale": "Stale",
  "admin.liveStatusOffline": "Offline",
  "admin.liveStatusUnknown": "Unknown",
  "admin.noRecentLiveUpdate": "No recent update",
  "admin.secondsAgo": "{count}s ago",
  "admin.minutesAgo": "{count}m ago",
  "admin.hoursAgo": "{count}h ago",
  "admin.liveHintLive": "The user is updating normally.",
  "admin.liveHintStale": "There is no recent update. Signal, battery or background behavior may be the issue.",
  "admin.liveHintOffline": "No active live signal was found for this user.",
  "admin.copyDebugInfo": "Copy debug info",
  "admin.copyLocation": "Copy location",
  "admin.openGoogleMaps": "Open in Google Maps",
  "admin.debugCopied": "Debug info copied.",
  "admin.locationCopied": "Location copied.",
  "admin.noLiveSignal": "No active live signal was found.",
  "admin.updateAge": "Update age",
  "admin.battery": "Battery",
  "admin.dataSource": "Data source",
  "admin.lastKnownLocation": "Last known location",
  "admin.noLocationAvailable": "No location available.",
  "admin.livePermissionFallback": "Operational live data is not readable. Showing only available public data.",
  "admin.openLiveFocus": "Open Live with focus",
  "admin.liveProblemsTitle": "Live problems",
  "admin.liveProblemsBody": "Central check for athletes with delayed updates, no signal or SOS/Help.",
  "admin.searchTitle": "Admin search",
  "admin.searchBody": "Search for a user, cyclist, action, live problem or ID.",
  "admin.searchPlaceholder": "Name, email, athlete number, UID, action, eventId...",
  "admin.searchClear": "Clear search",
  "admin.searchUsers": "Users / Cyclists",
  "admin.searchActions": "Actions",
  "admin.searchLiveProblems": "Live problems",
  "admin.searchQuickIds": "Quick ID matches",
  "admin.searchNoResults": "No results found.",
  "admin.openCard": "Open card",
  "admin.openAction": "Open action",
  "admin.editAction": "Edit action",
  "admin.liveOk": "Live OK",
  "admin.liveProblemAll": "All",
  "admin.liveProblemHelp": "SOS / Help",
  "admin.liveProblemStale": "Delayed",
  "admin.liveProblemOffline": "No signal",
  "admin.liveProblemGrouped": "By action",
  "admin.issueTypeSOS": "SOS",
  "admin.issueTypeHELP": "Help",
  "admin.issueTypeUnknown": "Unknown",
  "admin.openLive": "Open Live",
  "admin.openUserCard": "Cyclist card",
  "admin.noLiveProblems": "There are no live problems.",
  "admin.offlineDetectionPartial": "There is not enough data for offline detection.",
  "admin.userCardUnavailable": "No safe user id is available for this card.",
  "admin.unknownAthlete": "Participant",
  "admin.liveGroupCounts": "Live {live} · Delayed {stale} · No signal {offline} · SOS {help}",
  "admin.noAvailableData": "No data available.",
  "admin.recentRoutes": "Recent routes",
  "admin.recentRoutesDeferred": "Admin reading of private routes is left for a later safe stage.",
  "admin.recentRoutesDeferredBody": "Full private routes are not displayed in this step.",
  "admin.usersPermissionTitle": "You do not have permission to view users.",
  "admin.usersPermissionBody": "The user card cannot be read with the current permissions.",
  "admin.livePermissionDenied": "Live details for this user are not allowed.",
  "admin.userNotFoundTitle": "User not found",
  "admin.userNotFoundBody": "There is no user card for this ID.",
  "admin.backToAdmin": "Back to Admin",
  "admin.noUsers": "No user summaries available.",
  "admin.usersUnavailable": "User reading was not available with the current rules.",
  "admin.userStatusActive": "active",
  "admin.lastSeen": "Last seen",
  "admin.systemTitle": "System status",
  "admin.systemDescription": "Control links for Web V2, public pages and Android App Links.",
  "admin.policy": "Policy",
  "admin.systemServices": "Services",
  "admin.participants": "participants",
  "admin.statusDraft": "Draft",
  "admin.statusUpcoming": "Upcoming",
  "admin.statusOngoing": "Ongoing",
  "admin.statusCompleted": "Completed",
  "admin.statusCancelled": "Cancelled",
  "admin.statusDeleted": "Deleted",
  "admin.eventTypeRace": "Race",
  "admin.eventTypeGroupRide": "Group ride",
  "admin.eventTypeTraining": "Training",
  "admin.eventTypeCharity": "Charity",
  "admin.eventTypeTour": "Tour",
  "admin.eventTypeOther": "Other action",

  "actions.title": "Tasks",
  "actions.subtitle": "Personal inbox for invitations, support/control and SOS / Help.",
  "actions.authSubtitle": "Invitations, support/control and SOS require sign-in.",
  "actions.authBody": "Sign in to see your personal PULS tasks.",
  "actions.pending": "Pending",
  "actions.loadingAccount": "Loading account",
  "actions.loadingAccountBody": "Checking your session.",
  "actions.loadingInboxBody": "Reading pending items.",
  "actions.loadError": "Could not load",
  "actions.emptyTitle": "No pending items",
  "actions.invitationsTitle": "Athlete invitations",
  "actions.invitationsSubtitle": "Invitations to join Actions.",
  "actions.invitationsEmpty": "There are no pending athlete invitations.",
  "actions.supportTitle": "Support / Control",
  "actions.supportSubtitle": "Role requests from organizers.",
  "actions.supportEmpty": "There are no pending support/control requests.",
  "actions.helpTitle": "SOS / Help",
  "actions.helpSubtitle": "Open requests assigned to your account.",
  "actions.helpEmpty": "There are no open SOS / help requests.",
  "actions.accept": "Accept",
  "actions.decline": "Decline",
  "actions.resolve": "Resolve",
  "actions.openAction": "Open action",
  "actions.fromOrganizer": "Invitation from",
  "actions.organizer": "organizer",
  "actions.recipient": "Recipient",
  "actions.currentUser": "current user",
  "actions.created": "Created",
  "actions.supportRequest": "Organizer {organizer} asks you to take the {role} role.",
  "actions.from": "From",
  "actions.athlete": "Athlete",
  "actions.invitationAccepted": "The invitation was accepted.",
  "actions.invitationDeclined": "The invitation was declined.",
  "actions.requestAccepted": "The request was accepted.",
  "actions.requestDeclined": "The request was declined.",
  "actions.helpResolved": "The SOS / help request was marked as resolved.",
  "actions.errorGeneric": "The action could not be completed.",
  "actions.errorPermission": "You do not have permission for this action.",
  "actions.errorIndex": "This query needs a Firestore index. The page stayed safe and did not change data.",
  "actions.errorInvitationNotPending": "The invitation is no longer pending.",
  "actions.errorInvitationNoAccess": "The invitation does not belong to the current user.",
  "actions.errorCyclistProfile": "Brevet requires a completed athlete registry number in your profile.",
  "actions.errorEventFull": "The action is full.",
  "actions.errorRequestNotPending": "The request is no longer pending.",
  "actions.errorRequestNoAccess": "The request does not belong to the current user.",

  "status.pending": "Pending",
  "status.accepted": "Accepted",
  "status.declined": "Declined",
  "status.expired": "Expired",
  "status.open": "Open",
  "status.resolved": "Resolved",

  "role.support": "Support",
  "role.control": "Control",
  "role.organizer": "Organizer",
  "role.organizer_pending": "Organizer request",
  "role.admin": "Admin",
  "role.cyclist": "Athlete",
  "help.withdrawal": "Withdrawal",

  "profile.title": "Profile",
  "profile.subtitle": "Your personal hub for actions, routes, pending work, and account information.",
  "profile.loading": "Loading profile",
  "profile.loadingBody": "Reading your account details.",
  "profile.signInRequired": "Sign in to view your profile",
  "profile.signInRequiredBody": "The profile shows only your own safe account data, routes, and pending actions.",
  "profile.defaultName": "PULS athlete",
  "profile.myCard": "My card",
  "profile.myCardBody": "Basic data from your own account.",
  "profile.displayName": "Name",
  "profile.settingsTitle": "Profile settings",
  "profile.settingsBody": "Update the safe public details shown in PULS.",
  "profile.displayNameLabel": "Display name",
  "profile.photoUrlLabel": "Profile photo",
  "profile.changePhoto": "Change photo",
  "profile.deletePhoto": "Delete photo",
  "profile.choosePhotoFile": "Choose file",
  "profile.uploadingPhoto": "Uploading photo...",
  "profile.photoUpdated": "Photo updated.",
  "profile.photoDeleted": "Photo deleted.",
  "profile.photoUploadError": "Could not upload photo.",
  "profile.photoDeleteError": "Could not delete photo.",
  "profile.invalidPhotoFile": "Choose a JPG, PNG, or WebP image up to 5MB.",
  "profile.photoHiddenHelp": "The photo is uploaded to PULS and the URL is not displayed as text on your profile.",
  "profile.saveProfile": "Save profile",
  "profile.profileUpdated": "Profile updated.",
  "profile.profileSaveError": "Could not save your profile.",
  "profile.profilePermissionError": "You do not have permission to change these details.",
  "profile.privacyVisibility": "Privacy and visibility",
  "profile.privacyVisibilityBody": "Controls for what appears on your public profile card.",
  "profile.publicProfile": "Public profile",
  "profile.publicProfileBody": "Enables your public profile card on puls.gr.",
  "profile.showPerformancePublicly": "Show performance publicly",
  "profile.showPerformancePubliclyBody": "Marks that only public-safe stats may be shown when a public data model is available.",
  "profile.showRoutesPublicly": "Show routes publicly",
  "profile.showRoutesPubliclyBody": "Marks that public routes may be shown when a safe public mirror is enabled.",
  "profile.enablePublicProfileFirst": "Enable the public profile first to choose public sections.",
  "profile.publicProfileLink": "Public profile link",
  "profile.copyProfileLink": "Copy link",
  "profile.profileLinkCopied": "Link copied",
  "profile.publicProfileLoading": "Reading the public profile card.",
  "profile.publicProfileUnavailable": "The public profile is not available.",
  "profile.publicProfileUnavailableBody": "The user has not enabled a public profile or the link is incorrect.",
  "profile.publicAthleteCard": "Public athlete card",
  "profile.publicStatsPlaceholder": "Public stats will appear when public-safe data is available.",
  "profile.publicRoutesDeferred": "Public routes will be enabled in a later step.",
  "profile.preferredLanguage": "Preferred language",
  "profile.localLanguageSetting": "Local language setting in this browser.",
  "profile.futureOption": "Will be enabled in a later step.",
  "profile.liveSharingVisibility": "Live sharing is visible to anyone who has the link.",
  "profile.resultsVisibilityNote": "Action results may appear publicly with safe fields.",
  "profile.email": "Email",
  "profile.providers": "Sign-in provider",
  "profile.language": "Language",
  "profile.roles": "Roles",
  "profile.rolesBody": "Roles are derived from your account and actions.",
  "profile.myActions": "My actions",
  "profile.myActionsBody": "Actions where you are organizer, participant, support, or control.",
  "profile.openActions": "Open actions",
  "profile.myRoutes": "My routes",
  "profile.myRoutesBody": "Recent saved and imported routes.",
  "profile.openRoutes": "Open routes",
  "profile.openRouteEditor": "Edit / Create",
  "profile.myTasks": "My tasks",
  "profile.myTasksBody": "Pending invitations, support/control requests, and SOS.",
  "profile.openTasks": "Open tasks",
  "profile.myPerformance": "My performance",
  "profile.myPerformanceBody": "Real personal statistics from your saved routes.",
  "profile.performanceFilter": "Performance filter",
  "profile.filterAll": "All",
  "profile.profileBicycle": "Bicycle",
  "profile.profileElectricBike": "Electric bike",
  "profile.profileHiking": "Hiking",
  "profile.profileMotorVehicle": "Motor vehicle",
  "profile.profileOther": "Other / legacy",
  "profile.totalRoutes": "Routes",
  "profile.totalTime": "Total time",
  "profile.averageSpeed": "Average speed",
  "profile.maxSpeed": "Max speed",
  "profile.distanceByMonth": "Distance by month",
  "profile.elevationByMonth": "Elevation by month",
  "profile.activitiesByMonth": "Activities by month",
  "profile.personalRecords": "Personal records",
  "profile.mostElevation": "Most elevation",
  "profile.bestAverageSpeed": "Best average speed",
  "profile.longestDuration": "Longest duration",
  "profile.recentActivities": "Recent activities",
  "profile.openRecord": "Open",
  "profile.noPerformanceData": "No data for this filter yet.",
  "profile.privacyAccount": "Privacy and account",
  "profile.privacyBody": "Links for privacy policy and account deletion.",
  "profile.publicLinksNote": "Public live links are visible to anyone who has the link.",
  "profile.privacyPolicy": "Privacy policy",
  "profile.accountDeletion": "Account deletion",
  "profile.recentRoutes": "Recent routes",
  "profile.pending": "Pending",
  "profile.totalDistance": "Total distance",
  "profile.longestRoute": "Longest route",
  "profile.totalElevation": "Total elevation",
  "profile.recentActivity": "Recent activity",
  "profile.noData": "No data yet",
  "profile.invitations": "Invitations",
  "profile.supportControl": "Support / Control",
  "profile.helpSos": "SOS / Help",
  "profile.profileLoadError": "Could not load your profile card.",
  "profile.routesLoadError": "Could not load your routes.",
  "profile.actionsLoadError": "Could not load your actions.",
  "profile.pendingLoadError": "Could not load pending actions.",
  "profile.readOnlyProfile": "Profile editing will be added separately when the safe write model is finalized.",

  "events.title": "Actions",
  "events.myTitle": "My actions",
  "events.subtitle": "Public action viewing. Participation mode controls joining, not visibility.",
  "events.mySubtitle": "Only actions where you are organizer, participant, support or control.",
  "events.newAction": "New Action",
  "events.invitationsRequests": "Invitations & requests",
  "events.loadingTitle": "Loading actions",
  "events.loadingPublic": "Reading public actions.",
  "events.loadingMine": "Reading your actions.",
  "events.loadErrorTitle": "Could not load",
  "events.loadErrorBody": "Try again in a moment. This page does not modify data.",
  "events.emptyPublicTitle": "No actions available",
  "events.emptyMineTitle": "No actions found for you",
  "events.emptyPublicBody": "Deleted, draft or cancelled actions are not shown in the public list.",
  "events.emptyMineBody": "Actions where you are organizer, participant, support or control will appear here.",
  "events.photo": "Action photo",
  "events.noLocation": "No location set",
  "events.registrationDeadline": "Deadline",
  "events.untilStart": "until start",
  "events.participants": "participants",

  "routes.title": "My routes",
  "routes.subtitle": "Synced routes from the app, together with imported community routes.",
  "routes.authSubtitle": "Personal and imported routes from the app.",
  "routes.count": "{count} routes",
  "routes.loadingAccount": "Checking session",
  "routes.loadingAccountBody": "Reading your account.",
  "routes.signInRequired": "Sign-in required",
  "routes.signInRequiredBody": "Sign in to see your saved routes.",
  "routes.loadingTitle": "Loading routes",
  "routes.loadingBody": "Reading your personal Firestore sync.",
  "routes.loadErrorTitle": "Could not load",
  "routes.loadErrorBody": "Check that you are signed in with the same account used in the app.",
  "routes.emptyTitle": "No synced routes",
  "routes.emptyBody": "Routes appear here after they are saved/synced from the Android app or web editor.",
  "routes.recordedSection": "Recorded in the app",
  "routes.importedSection": "Imported routes",
  "routes.imported": "Imported",
  "routes.own": "Mine",
  "routes.points": "points",
  "routes.routePoints": "route points",
  "routes.profileBicycle": "Bicycle",
  "routes.profileElectricBike": "Electric bike",
  "routes.profileHiking": "Walking / hiking",
  "routes.profileMotorVehicle": "Motor vehicle",
  "routes.profileLegacy": "Legacy / no profile",

  "detail.actionDetails": "Action details",
  "detail.publicAction": "Public action view.",
  "detail.legacyAction": "Compatible /event/:eventId link in the new Web V2.",
  "detail.participants": "Participants",
  "detail.invitations": "Invitations",
  "detail.supportControl": "Support / Control",
  "detail.results": "Results",
  "detail.editRoute": "Edit route",
  "detail.editAction": "Edit Action",
  "detail.useSavedRoute": "Choose from My routes",

  "public.live": "Live",
  "public.inactive": "Inactive",
  "public.stale": "Stale",
  "public.speed": "Speed",
  "public.average": "Average",
  "public.max": "Max",
  "public.distance": "Distance",
  "public.duration": "Duration",
  "public.elevation": "Elevation gain",
  "public.altitude": "Altitude",
  "public.points": "Points",
  "public.lastUpdate": "Last update",
  "public.liveMap": "Live map",
  "public.missingLink": "The link is incomplete",
  "public.missingEvent": "There is no action id in this link.",
  "public.missingSession": "There is no live session id in this link.",
  "public.trackShareTools": "Share live location",
  "public.trackShareToolsBody": "Copy safe share text or a social preview link without exact coordinates.",
  "public.trackShareTitle": "📍 PULS live location",
  "public.trackShareBody": "{name} is sharing their live location.",
  "public.trackShareOpen": "Open live tracking:",
  "public.trackShareDownload": "Download the PULS app:",

  "liveControl.title": "Live Race Control Room",
  "liveControl.publicAccess": "Public view",
  "liveControl.signedInAccess": "Signed-in user",
  "liveControl.checkingAccess": "Checking access",
  "liveControl.adminAccess": "Admin control room",
  "liveControl.organizerAccess": "Organizer",
  "liveControl.supportAccess": "Support",
  "liveControl.controlAccess": "Control",
  "liveControl.privateDeniedTitle": "Private control room",
  "liveControl.privateDeniedBody": "The private live athletes list requires organizer/support/control access. Public viewing continues from the public live mirror.",
  "liveControl.noMirrorTitle": "No public live mirror yet",
  "liveControl.noMirrorBody": "The action loaded from Firestore, but no live athletes are available in the public RTDB mirror yet.",
  "liveControl.closedTitle": "Live tracking has ended",
  "liveControl.closedBody": "The action has ended or was cancelled, so athlete locations are no longer shown.",
  "liveControl.publicLoadError": "The public live event could not be read. No data was changed.",
  "liveControl.totalAthletes": "Total athletes",
  "liveControl.liveAthletes": "Live athletes",
  "liveControl.staleAthletes": "Stale",
  "liveControl.openHelp": "Open SOS",
  "liveControl.located": "located",
  "liveControl.athletes": "Athletes",
  "liveControl.athletesBody": "Search, filters and map focus.",
  "liveControl.searchAthlete": "Search name or number",
  "liveControl.filterALL": "All",
  "liveControl.filterLIVE": "Live",
  "liveControl.filterSTALE": "Stale",
  "liveControl.filterSOS": "SOS",
  "liveControl.filterDONE": "Finished / Withdrawn",
  "liveControl.noAthletes": "No athletes match this filter.",
  "liveControl.live": "Live",
  "liveControl.stale": "Stale",
  "liveControl.offline": "Offline",
  "liveControl.paused": "Paused",
  "liveControl.finished": "Finished",
  "liveControl.withdrawn": "Withdrawn",
  "liveControl.battery": "Battery",
  "liveControl.hasHelp": "SOS / Help",
  "liveControl.mapTitle": "Live control map",
  "liveControl.mapBody": "Athletes, route and Roadbook points on one map.",
  "liveControl.mapLoadError": "The map could not be loaded.",
  "liveControl.followingAthlete": "Focused: {name}",
  "liveControl.athleteNotFound": "The athlete is not live right now.",
  "liveControl.fitAll": "Fit all",
  "liveControl.clearSelection": "Clear selection",
  "liveControl.helpTitle": "SOS / Help",
  "liveControl.helpBody": "Open requests assigned to you.",
  "liveControl.helpPublicBody": "Operational SOS items are shown only to organizer/support/control users.",
  "liveControl.helpLoading": "Loading SOS / Help...",
  "liveControl.helpError": "SOS could not be loaded or updated.",
  "liveControl.noHelp": "There are no open SOS / help requests.",
  "liveControl.dataSourceTitle": "Data source",
  "liveControl.publicDataSource": "Public viewing uses public_live_events and does not show private fields.",
  "liveControl.operationalDataSource": "The control room uses the public live mirror and, where allowed, private live_events access.",
  "liveControl.privacyTitle": "Privacy-safe",
  "liveControl.privacyBody": "Phone, email, emergency fields and raw user ids are not shown.",
  "liveControl.doneSummary": "{count} athletes have finished or withdrawn.",

  "routeEditor.title": "Edit / Create route",
  "routeEditor.import": "Import file",
  "routeEditor.routeMode": "Route",
  "routeEditor.poiMode": "Points of interest",
  "routeEditor.start": "Start",
  "routeEditor.finish": "Finish",
  "routeEditor.waypoint": "Waypoint",
  "routeEditor.save": "Save",
  "routeEditor.update": "Update route",
  "routeEditor.copy": "Save copy",
  "routeEditor.undo": "Undo",
  "routeEditor.clear": "Clear",
  "routeEditor.discard": "Discard",
  "routeEditor.draftRecovery": "Draft recovery",
  "routeEditor.collapseTools": "Collapse tools",
  "routeEditor.openTools": "Open tools",
  "routeEditor.fullMap": "Full map",
  "routeEditor.showTools": "Show tools",
  "routeEditor.shortcuts": "Shortcuts",
  "routeEditor.shortcutsHint": "Shortcuts: Ctrl+Z undo, Esc cancel tool.",
  "routeEditor.cancelTool": "Cancel tool",
  "routeEditor.sectionImport": "Import file",
  "routeEditor.sectionRoute": "Route",
  "routeEditor.sectionCorrection": "Correction tools",
  "routeEditor.sectionMarkers": "Route points",
  "routeEditor.sectionRoadbook": "Roadbook",
  "routeEditor.sectionSave": "Save",
  "routeEditor.kmTools": "Kilometer tools",
  "routeEditor.type": "Type",
  "routeEditor.titleField": "Title",
  "routeEditor.descriptionField": "Description",
  "routeEditor.moveToKm": "Move to km",
  "routeEditor.visibleToAthletes": "Visible to athletes",
  "routeEditor.localMarkers": "local markers in workspace",
  "routeEditor.kmAutoHint": "km is updated automatically when the point is placed near the route.",
  "routeEditor.correctionTools": "Correction tools",
  "routeEditor.correctionToolsHint": "Reverse, trim or safely clean the route line before saving.",
  "routeEditor.reverseRoute": "Reverse route",
  "routeEditor.trimStart": "Trim start",
  "routeEditor.trimFinish": "Trim finish",
  "routeEditor.cleanRoute": "Clean route",
  "routeEditor.trimToolHint": "Click on the route to choose a point.",
  "routeEditor.routeRequiredForCorrection": "Calculate or import a route first.",
  "routeEditor.correctionRouteTooShort": "The route would be too short after this correction.",
  "routeEditor.trimPointTooFar": "The point is far from the route.",
  "routeEditor.routeReversed": "The route was reversed.",
  "routeEditor.routeTrimmedStart": "The start of the route was trimmed.",
  "routeEditor.routeTrimmedFinish": "The finish of the route was trimmed.",
  "routeEditor.routeCleaned": "Route cleaned. Removed {count} points.",
  "routeEditor.routeAlreadyClean": "No problematic points were found.",
  "routeEditor.markerFarWarning": "Some points of interest are far from the new route.",
  "routeEditor.unifiedSearchLabel": "Search",
  "routeEditor.unifiedSearchPlaceholder": "Search location or route point",
  "routeEditor.placesGroup": "Locations",
  "routeEditor.routePointsGroup": "Route points",
  "routeEditor.noSearchResults": "No results found",
  "routeEditor.selectTargetFirst": "Choose a target for the location first",
  "routeEditor.target": "Target",
  "routeEditor.placesMinChars": "Location suggestions appear after 5 characters.",
  "routeEditor.placesLoading": "Loading suggestions...",
  "routeEditor.placeSelectError": "The location could not be selected.",
  "routeEditor.markerListHint": "Points are filtered by the shared search above.",
  "routeEditor.routePointSuggestions": "Point suggestions",
  "routeEditor.elevationCalculating": "Calculating elevation...",
  "routeEditor.elevationFailed": "Elevation could not be calculated.",
  "routeEditor.elevationRetry": "Try again",
  "routeEditor.saveWithoutElevation": "Save without elevation",
  "routeEditor.exportGpx": "Export GPX",
  "routeEditor.gpxCreating": "Creating GPX...",
  "routeEditor.noRouteToExport": "There is no route to export.",
  "routeEditor.gpxExportSuccess": "The GPX was created for download.",
  "routeEditor.gpxExportFailed": "Could not export GPX.",
  "routeEditor.noElevationWarning": "The route has no elevation data.",
  "routeEditor.exportWithoutElevationHint": "Save first to calculate elevation, or export without elevation.",
  "routeEditor.exportWithoutElevation": "Export without elevation",
  "routeEditor.gpxIncludesElevation": "The GPX export includes elevation.",
  "routeEditor.saveSuccessWithTime": "Saved successfully. Last saved: {time}",
  "routeEditor.saveFailed": "The route could not be saved.",
  "routeEditor.updateFailed": "The route could not be updated.",

  "common.close": "Close",
  "common.points": "points",
  "common.routePoints": "route points",
  "common.saving": "Saving...",
  "common.replacing": "Replacing",
  "common.unknown": "Unknown",

  "eventType.BREVET": "Brevet",
  "eventType.RACE": "Race",
  "eventType.GROUPRIDE": "Group ride",
  "eventType.TRAINING": "Training",
  "eventType.CHARITY": "Charity",
  "eventType.TOUR": "Tour",
  "eventType.OTHER": "Other action",
  "eventStatus.UPCOMING": "Upcoming",
  "eventStatus.ONGOING": "Ongoing",
  "eventStatus.COMPLETED": "Completed",
  "eventStatus.DRAFT": "Draft",
  "eventStatus.CANCELLED": "Cancelled",
  "eventStatus.CANCELED": "Cancelled",
  "participationMode.OPEN": "Open participation",
  "participationMode.APPROVAL_REQUIRED": "Approval required",
  "participationMode.INVITE_ONLY": "Invite only",

  "preview.defaultTitle": "Preview",
  "preview.actionPhoto": "Action photo",
  "preview.noVisual": "No photo or route preview is available yet.",

  "routeMarkers.title": "Route markers",
  "routeMarkers.emptyPublic": "No public route markers have been added.",
  "routeMarkers.loading": "Loading route markers...",
  "routeMarkers.loadError": "Route markers could not be loaded.",
  "routeMarkers.pointOfInterest": "Point of interest",

  "elevationProfile.title": "Elevation profile",
  "elevationProfile.notEnoughData": "There are not enough points with altitude for a chart.",

  "savedRoute.mapTitle": "Route map",
  "savedRoute.mapDescription": "Full route view with start, finish and points of interest.",
  "savedRoute.largeMap": "Large map",
  "savedRoute.largeMapDescription": "Large route map.",
  "savedRoute.mapLoadError": "The map could not be loaded. The route is shown in a simple preview.",
  "savedRoute.routeHighlightsTitle": "Route highlights",
  "savedRoute.routeHighlightsBody": "Important points from the saved recording.",
  "savedRoute.noRouteHighlights": "There is not enough data for route highlights.",
  "savedRoute.maxSpeedPoint": "Maximum speed",
  "savedRoute.maxAltitudePoint": "Highest altitude",
  "savedRoute.focusMap": "Focus on map",
  "savedRoute.kmAlongRoute": "Route km",
  "savedRoute.time": "Time",
  "savedRoute.altitude": "Altitude",
  "savedRoute.climbsTitle": "Possible climbs",
  "savedRoute.climbsBody": "Local climb detection using logic equivalent to the Android app.",
  "savedRoute.climbsCount": "{count} possible",
  "savedRoute.climbLabel": "Possible climb {index}",
  "savedRoute.viewOnMap": "View on map",
  "savedRoute.noClimbs": "No possible climbs were detected on this route.",
  "savedRoute.climbsUnsupported": "Climb detection does not apply to this route type.",
  "savedRoute.from": "From",
  "savedRoute.to": "To",
  "savedRoute.elevationGain": "Elevation gain",
  "savedRoute.averageGrade": "Average grade",
  "savedRoute.climbStart": "Climb start",
  "savedRoute.climbFinish": "Climb finish",
  "savedRoute.hours": "Hours",
  "savedRoute.water": "Water",
  "savedRoute.food": "Food",
  "savedRoute.coffee": "Stop / Coffee",
  "savedRoute.warning": "Warning",
  "savedRoute.service": "Service",
  "savedRoute.photo": "Photo",
  "savedRoute.note": "Note",
  "savedRoute.personalDescription": "Personal saved route from the app or web editor.",
  "savedRoute.edit": "Edit",
  "savedRoute.openInEditor": "Open in Route Editor",
  "savedRoute.useInAction": "Use in Action",
  "savedRoute.downloadGpx": "Download GPX",
  "savedRoute.missingTitle": "Route is missing",
  "savedRoute.missingBody": "This link does not contain a ride id.",
  "savedRoute.loadingTitle": "Loading route",
  "savedRoute.loadingBody": "Reading the personal route.",
  "savedRoute.loadErrorTitle": "Could not load",
  "savedRoute.loadErrorBody": "The route could not be read from your personal Firestore.",
  "savedRoute.notFoundTitle": "Route not found",
  "savedRoute.notFoundBody": "It may have been deleted or belong to another account.",
  "savedRoute.authBody": "Sign in to see your personal saved routes.",
  "savedRoute.poiTitle": "Points of interest / control",
  "savedRoute.poiBody": "Points saved together with the route.",
  "savedRoute.noPoi": "No saved points of interest.",
  "savedRoute.activityChangeType": "Change activity type",
  "savedRoute.activityChangeTypeBody": "Choose the correct type without changing route geometry, GPS points or route stats.",
  "savedRoute.activityExcludeFromRecords": "Exclude from personal records",
  "savedRoute.activityIncludeInRecords": "Include in personal records",
  "savedRoute.activityExcludeConfirmBody": "The route will remain saved, but it will not count toward your bests, personal records or segment attempts.",
  "savedRoute.activityIncludeConfirmBody": "The route can count again toward personal stats, as long as it is not still suspicious or incompatible with its type.",
  "savedRoute.activitySuspiciousTitle": "Suspicious activity",
  "savedRoute.activitySuspiciousBody": "This route looks incompatible with the selected activity type. Correct the type or exclude it from records.",
  "savedRoute.activityExcludedTitle": "Excluded from personal records",
  "savedRoute.activityExcludedBody": "The route remains saved, but it does not count toward your bests or segment attempts.",
  "savedRoute.activityKeepAsIs": "Keep as-is",
  "savedRoute.activityTypeUpdated": "Activity type updated.",
  "savedRoute.activityExcludedFromRecords": "The route was excluded from records.",
  "savedRoute.activityIncludedInRecords": "The route can count toward records again.",
  "savedRoute.activityKeptAsIs": "The route was confirmed as-is.",
  "savedRoute.activityUpdateFailed": "The route could not be updated.",
  "savedRoute.activityFlagHikingSpeedHigh": "The hiking activity has unusually high speed.",
  "savedRoute.activityFlagBicycleSpeedHigh": "The bicycle activity has unusually high speed.",
  "savedRoute.activityFlagEbikeSpeedHigh": "The e-bike activity has unusually high speed.",
  "savedRoute.activityFlagCarLikeSpeed": "The route looks like motorized travel.",
  "savedRoute.activityFlagTeleportJump": "There may be a GPS jump or unrealistic segment.",
  "savedRoute.activityFlagGeneric": "The route needs review.",
  "savedRoute.stats": "Stats",
  "savedRoute.summary": "Route point summary",
  "savedRoute.routePoints": "Route points",
  "savedRoute.controlPoiPoints": "Control / POI points",
  "savedRoute.firstPoint": "First point",
  "savedRoute.lastPoint": "Last point",
  "savedRoute.file": "File",
  "savedRoute.createSegment": "Create segment",
  "savedRoute.segmentCreateTitle": "Create segment from climb",
  "savedRoute.segmentCreateBody": "Adjust start/finish, name it and save the segment to Community.",
  "savedRoute.defaultSegmentTitle": "Climb {from}-{to} km",
  "savedRoute.segmentName": "Segment name",
  "savedRoute.segmentDescription": "Description",
  "savedRoute.segmentProfile": "Profile",
  "savedRoute.segmentStartKm": "Start (km)",
  "savedRoute.segmentFinishKm": "Finish (km)",
  "savedRoute.selectStartEndpoint": "Change start",
  "savedRoute.selectFinishEndpoint": "Change finish",
  "savedRoute.endpointStart": "start",
  "savedRoute.endpointFinish": "finish",
  "savedRoute.segmentAdjustHint": "Active point: {endpoint}. Click the blue route line or edit the km values.",
  "savedRoute.segmentInvalidEndpoints": "Start must be before finish and include enough route points.",
  "savedRoute.segmentTooShort": "The segment must be at least 100 m long.",
  "savedRoute.segmentTitleRequired": "Enter a segment name.",
  "savedRoute.segmentUnsupportedProfile": "This profile is not supported for segments.",
  "savedRoute.segmentSaving": "Saving...",
  "savedRoute.saveSegment": "Save segment",
  "savedRoute.segmentSaveSuccess": "The segment was saved and will appear in Segments.",
  "savedRoute.segmentSaveFailed": "The segment could not be saved.",
  "savedRoute.openSegments": "Open Segments",
  "stats.distance": "Distance",
  "stats.duration": "Duration",
  "stats.average": "Average",
  "stats.max": "Max",
  "stats.elevationGain": "Elevation +",
  "stats.elevationLoss": "Elevation -",
  "stats.minAltitude": "Min altitude",
  "stats.maxAltitude": "Max altitude",
  "stats.points": "Points",

  "attachRoute.title": "Attach route to action",
  "attachRoute.description": "The route will be uploaded as GPX and will update the action preview.",
  "attachRoute.chooseAction": "Choose action",
  "attachRoute.action": "Action",
  "attachRoute.chooseRoute": "Choose route",
  "attachRoute.route": "Route",
  "attachRoute.loadingActions": "Loading actions...",
  "attachRoute.loadingRoutes": "Loading routes...",
  "attachRoute.noEditableActions": "No editable actions were found.",
  "attachRoute.noRoutes": "No saved routes with valid points were found.",
  "attachRoute.replaceWarning": "This action already has a route. I want to replace it with the selected route.",
  "attachRoute.transferMarkers": "Transfer route markers to the action",
  "attachRoute.transferMarkersAvailable": "add without deleting existing markers",
  "attachRoute.transferMarkersUnavailable": "there are no markers in the route",
  "attachRoute.submit": "Attach route",
  "attachRoute.submitting": "Attaching...",
  "attachRoute.success": "The route was attached to the action.",
  "attachRoute.successWithMarkers": "The route was attached to the action and {count} markers were added.",
  "attachRoute.loadActionsError": "Could not load the actions you can edit.",
  "attachRoute.loadRoutesError": "Could not load your routes.",
  "attachRoute.permissionError": "You do not have permission to update this action or upload this route.",
  "attachRoute.routePointsRequired": "The route does not have enough points to attach to an action.",
  "attachRoute.genericError": "The route could not be attached to the action.",
  "actionForm.createTitle": "New Action",
  "actionForm.editTitle": "Edit Action",
  "actionForm.subtitle": "All actions are publicly visible. Participation mode only controls who can join.",
  "actionForm.createPill": "Create",
  "actionForm.editPill": "Edit",
  "actionForm.basic": "Basic details",
  "actionForm.title": "Title",
  "actionForm.description": "Description",
  "actionForm.actionType": "Action type",
  "actionForm.status": "Status",
  "actionForm.targetSpeed": "Average/target km/h",
  "actionForm.photoUrl": "Photo URL optional",
  "actionForm.time": "Time",
  "actionForm.start": "Start",
  "actionForm.end": "End",
  "actionForm.durationHours": "Duration hours",
  "actionForm.registrationDeadline": "Registration deadline",
  "actionForm.startLocation": "Start location",
  "actionForm.locationName": "Location name",
  "actionForm.participation": "Participation",
  "actionForm.maxParticipants": "Max participants",
  "actionForm.participationMode": "Participation mode",
  "actionForm.allowParticipantLiveMap": "Allow participant live map where supported.",
  "actionForm.route": "Route",
  "actionForm.routeDescription": "You can leave the action without a route or choose one of your saved routes.",
  "actionForm.existingRouteWarning": "This action already has a route. A new selection will replace it after confirmation.",
  "actionForm.noRouteChange": "No route change",
  "actionForm.noRouteChangeBody": "The action will stay without a new route or keep the existing one.",
  "actionForm.replaceRouteConfirm": "This action already has a route. I want to replace it.",
  "actionForm.transferMarkers": "Transfer route markers to the action as additions.",
  "actionForm.checkDetails": "Check the details",
  "actionForm.saveAction": "Save Action",
  "actionForm.cancel": "Cancel",
  "actionForm.loadingAction": "Loading action",
  "actionForm.loadingActionBody": "Reading from Firestore.",
  "actionForm.signInBody": "Sign in to create or edit an action.",
  "actionForm.editNotAllowedTitle": "Editing not allowed",
  "actionForm.editNotAllowedBody": "For now, web editing is shown only to the action organizer.",
  "actionForm.notFoundTitle": "Action not found",
  "actionForm.notFoundBody": "There is no editable action for this link.",
  "actionForm.saved": "The action was saved.",
  "actionForm.savedLink": "The action was saved: /event/{eventId}",
  "actionForm.routeAttachPartialWarning": "The action was saved, but the route was not attached. You can attach it from the action detail.",
  "actionForm.loadRoutesError": "Could not load your routes.",
  "actionForm.loadActionError": "Could not load the action.",
  "actionForm.permissionError": "You do not have permission to save this action.",
  "actionForm.saveError": "The action could not be saved.",
  "actionForm.errorTitleRequired": "Title is required.",
  "actionForm.errorStartRequired": "Start date is required.",
  "actionForm.errorEndAfterStart": "End must be after start.",
  "actionForm.errorDeadlineBeforeStart": "Registration deadline must be before start.",
  "actionForm.errorDuration": "Duration must be at least 1 hour.",
  "actionForm.errorParticipants": "Participants must be a positive number.",
  "actionForm.errorLatitude": "Latitude must be between -90 and 90.",
  "actionForm.errorLongitude": "Longitude must be between -180 and 180.",
  "actionForm.errorReplaceRoute": "This action already has a route. Confirm that you want to replace it.",

  "detail.resultsLoading": "Loading results",
  "detail.resultsLoadingBody": "Reading results without changing Firestore.",
  "detail.resultsLoadError": "Could not load results",
  "detail.resultsLoadErrorBody": "Results will appear when they are available and readable.",
  "detail.noFinishers": "There are no finishers yet.",
  "detail.nonFinishers": "Withdrawals / Did not finish",
  "detail.athlete": "Athlete",
  "detail.resultWithdrawn": "Withdrawn",
  "detail.resultDnf": "Did not finish",
  "detail.resultDisqualified": "Disqualified",

  "results.pageTitle": "Results",
  "results.pageSubtitle": "Select an action and review finishers, withdrawals, and CSV export clearly.",
  "results.title": "Action results",
  "results.subtitle": "Classification and public-safe result data.",
  "results.selectAction": "Select action",
  "results.selectActionBody": "Public Brevet or Race actions that can have results are shown here.",
  "results.loadingActions": "Loading actions",
  "results.noActionsTitle": "No result actions found",
  "results.noActionsBody": "Public Brevet or Race actions will appear here when available.",
  "results.chooseActionTitle": "Select an action",
  "results.chooseActionBody": "Open an action from the list to show its results.",
  "results.exportCsv": "Export results CSV",
  "results.ranking": "Classification",
  "results.rankingBody": "Only athletes with FINISHED status receive a rank.",
  "results.nonFinishedBody": "Withdrawn, did-not-finish, and disqualified athletes are shown without ranking positions.",
  "results.filterAll": "All",
  "results.filterFinished": "Finished",
  "results.filterNonFinished": "Withdrawn / Did not finish",
  "results.searchName": "Search by name",
  "results.emptyFiltered": "No results match this filter.",
  "results.rank": "Rank",
  "results.status": "Status",
  "results.athlete": "Athlete",
  "results.duration": "Duration",
  "results.distance": "Distance",
  "results.avgSpeed": "Avg speed",
  "results.maxSpeed": "Max speed",
  "results.elevationGain": "Elevation",
  "results.finishTime": "Finish time",
  "results.totalResults": "Total",
  "results.finishers": "Finishers",
  "results.withdrawnDnf": "Unranked",
  "results.fastestDuration": "Fastest duration",
  "results.averageFinishDuration": "Average duration",
  "results.statusFinished": "Finished",
  "results.statusWithdrawn": "Withdrawn",
  "results.statusDnf": "Did not finish",
  "results.statusDisqualified": "Disqualified",

  "detail.noDescription": "There is no description for this action.",
  "detail.untilStart": "Until start",
  "detail.basedOnDuration": "Based on duration",
  "detail.time": "Time",
  "detail.start": "Start",
  "detail.end": "End",
  "detail.registrationDeadline": "Registration deadline",
  "detail.location": "Location",
  "detail.noStartLocation": "No start location set",
  "detail.participation": "Participation",
  "detail.limit": "Limit",
  "detail.organizer": "Organizer",
  "detail.route": "Route",
  "detail.routePreview": "Route preview",
  "detail.routePreviewDescription": "{routePoints} preview points and {controlPoints} control points are available.",
  "detail.routePreviewEmpty": "The route will appear here when a map preview is available.",
  "detail.links": "Links",
  "detail.liveRace": "Live race",
  "detail.missingLinkTitle": "The link is incomplete",
  "detail.missingLinkBody": "There is no action id in this link.",
  "detail.loadingAction": "Loading action",
  "detail.loadingActionBody": "Reading from Firestore.",
  "detail.loadErrorTitle": "Could not load",
  "detail.loadErrorBody": "The action is not available or reading is not allowed.",
  "detail.unavailableTitle": "The action is not available",
  "detail.unavailableBody": "Deleted, draft or cancelled actions are not shown publicly.",
  "detail.nonRaceResultsBody": "Results appear for Brevet or race actions when available.",
  "detail.manageTitle": "Manage Action",
  "detail.manageBody": "Organizer-only tools for participants, invitations and support/control.",
  "detail.participantsPublicBody": "Public view of safe participant names.",
  "detail.participant": "Participant",
  "detail.participates": "Participates",
  "detail.loadingParticipants": "Loading participants...",
  "detail.participantsLoadError": "Participants could not be loaded.",
  "detail.noParticipants": "No participants found yet.",
  "detail.loadingPermissions": "Loading permissions",
  "detail.loadingPermissionsBody": "Checking account.",
  "detail.shareTools": "Share action",
  "detail.shareToolsBody": "Copy clean share text or a social link with the correct Facebook preview.",
  "detail.copyShareText": "Copy share text",
  "detail.copyShareLink": "Copy social link",
  "detail.facebookPreviewLink": "View social preview",
  "detail.shareCopied": "Copied.",
  "detail.shareCopyFailed": "Could not copy.",
  "detail.shareOpenInPuls": "Open in PULS:",
  "detail.shareDownloadPuls": "Download the PULS app:",
  "detail.shareFooter": "PULS - for bikes and more 🚴",
  "detail.shareParticipants": "{current} participants",
  "detail.shareParticipantsWithLimit": "{current}/{max} participants",

  "roadbook.title": "Roadbook",
  "roadbook.subtitle": "Route points table with km, type, opening times and visibility.",
  "roadbook.routeEditorTitle": "Route roadbook",
  "roadbook.routeEditorSubtitle": "All workspace markers sorted by route km.",
  "roadbook.savedRouteTitle": "Route roadbook",
  "roadbook.savedRouteSubtitle": "POIs and controls from the saved route.",
  "roadbook.actionTitle": "Action roadbook",
  "roadbook.publicSubtitle": "Public route points visible to athletes.",
  "roadbook.loading": "Loading route points...",
  "roadbook.print": "Print Roadbook",
  "roadbook.exportCsv": "Export CSV",
  "roadbook.km": "km",
  "roadbook.type": "Type",
  "roadbook.markerTitle": "Title",
  "roadbook.description": "Description",
  "roadbook.openTime": "Open",
  "roadbook.closeTime": "Close",
  "roadbook.visibility": "Visibility",
  "roadbook.actions": "Actions",
  "roadbook.visible": "Visible to athletes",
  "roadbook.hidden": "Hidden",
  "roadbook.empty": "There are no route points.",
  "roadbook.noKm": "No km",
  "roadbook.farFromRoute": "Far from route",
  "roadbook.publicCount": "{count} public",
  "roadbook.hiddenCount": "{count} hidden",
  "roadbook.edit": "Edit",
  "roadbook.recalculateKm": "Recalculate km",
  "roadbook.kmRecalculated": "Marker km values were updated.",
  "roadbook.kmAlreadyUpdated": "Marker km values are already up to date.",

  "community.routesTitle": "Community routes",
  "community.routesSubtitle": "Public routes published from the Android app.",
  "community.routesCount": "{count} routes",
  "community.routeDescription": "Public community route",
  "community.routeFallback": "Community route",
  "community.byAuthor": "By {name}",
  "community.noRating": "No rating",
  "community.hiddenEndpoints": "Hidden endpoints",
  "community.loadingRoutes": "Loading community",
  "community.loadingRoutesBody": "Reading public communityRoutes.",
  "community.routesLoadError": "Could not load",
  "community.routesLoadErrorBody": "Community requires sign-in and public published routes.",
  "community.noRoutes": "No published routes",
  "community.noRoutesBody": "Routes appear here when someone publishes them from the app.",
  "community.topRated": "Top ratings",
  "community.difficultyEasy": "Easy",
  "community.difficultyModerate": "Moderate",
  "community.difficultyHard": "Hard",
  "community.difficultyExpert": "Expert",
  "community.suitableHiking": "Walking",
  "community.suitableRoad": "Road",
  "community.segmentsTitle": "Segments",
  "community.segmentsSubtitle": "Public segments/climbs from the app, separated by movement profile.",
  "community.segmentsCount": "{count} segments",
  "community.segmentDescription": "Public community segment",
  "community.segmentFallback": "Segment",
  "community.noProfile": "No profile",
  "community.profileHiking": "Hiking",
  "community.attempts": "attempts",
  "community.loadingSegments": "Loading segments",
  "community.loadingSegmentsBody": "Reading ACTIVE PUBLIC communitySegments.",
  "community.segmentsLoadErrorBody": "Reading segments requires sign-in and public active segments.",
  "community.noSegments": "No segments yet",
  "community.noSegmentsBody": "Segments appear here when created from a saved route in the app.",
  "community.leaderboardTitle": "Segment leaderboard",
  "community.leaderboardSubtitle": "Only VALID attempts, separated by movement profile.",
  "community.loadingLeaderboard": "Loading leaderboard",
  "community.loadingLeaderboardBody": "Reading VALID segmentAttempts.",
  "community.leaderboardLoadErrorBody": "Leaderboard requires sign-in and valid segment attempts.",
  "community.noAttempts": "No valid attempts yet",
  "community.noAttemptsBody": "NEEDS_REVIEW and REJECTED attempts are not shown in the leaderboard."
} satisfies Record<string, string>;
